var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "modalEntidades",
          attrs: {
            "hide-footer": "",
            size: "lg",
            id: "modalEntidades",
            title: "Gestión Entidad"
          },
          on: {
            hidden: function($event) {
              _vm.$parent.closeAltaEntidad()
            }
          }
        },
        [
          _c("b-card", { staticClass: "mb-16" }, [
            _c("div", [_c("h5", [_vm._v("Buscar Entidad")])]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("b-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "searchEntity",
                  staticClass: "input-search-entity",
                  attrs: {
                    type: "search",
                    id: "searchEntity",
                    placeholder: "Introduce el CIF",
                    autofocus: ""
                  },
                  model: {
                    value: _vm.cif,
                    callback: function($$v) {
                      _vm.cif = $$v
                    },
                    expression: "cif"
                  }
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary" },
                    on: { click: _vm.searchEntity }
                  },
                  [_vm._v("Buscar")]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            [
              _c(
                "b-form",
                [
                  _c("div", [_c("h5", [_vm._v("Datos Entidad")])]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled:
                                      !_vm.searchedEntity || _vm.foundedEntity,
                                    label: "CIF *"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: { name: "Cif" },
                                    model: {
                                      value: _vm.entity.cif,
                                      callback: function($$v) {
                                        _vm.$set(_vm.entity, "cif", $$v)
                                      },
                                      expression: "entity.cif"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.errors.first("Cif")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Nombre *"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    attrs: {
                                      name: "Nombre",
                                      state:
                                        _vm.searchedEntity &&
                                        this.fields &&
                                        this.fields["Nombre"].invalid
                                          ? false
                                          : null
                                    },
                                    model: {
                                      value: _vm.entity.nombre_entidad,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "nombre_entidad",
                                          $$v
                                        )
                                      },
                                      expression: "entity.nombre_entidad"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.errors.first("Nombre")))
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Tipo Entidad *"
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "select-size",
                                    attrs: {
                                      options: _vm.entity_types,
                                      "value-field": "id",
                                      "text-field": "text",
                                      name: "Tipo Entidad",
                                      state:
                                        _vm.searchedEntity &&
                                        this.fields &&
                                        this.fields["Tipo Entidad"].invalid
                                          ? false
                                          : null
                                    },
                                    model: {
                                      value: _vm.entity.id_tipo_entidad,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "id_tipo_entidad",
                                          $$v
                                        )
                                      },
                                      expression: "entity.id_tipo_entidad"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Tipo Entidad"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Dirección *"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate.immediate",
                                        value: "required",
                                        expression: "'required'",
                                        modifiers: { immediate: true }
                                      }
                                    ],
                                    attrs: {
                                      name: "Dirección",
                                      state:
                                        _vm.searchedEntity &&
                                        this.fields &&
                                        this.fields["Dirección"].invalid
                                          ? false
                                          : null
                                    },
                                    model: {
                                      value: _vm.entity.direccion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.entity, "direccion", $$v)
                                      },
                                      expression: "entity.direccion"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "error" }, [
                                    _vm._v(
                                      _vm._s(_vm.errors.first("Dirección"))
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: 4 } },
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Código SAP"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.entity.codigo_entidad,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "codigo_entidad",
                                          $$v
                                        )
                                      },
                                      expression: "entity.codigo_entidad"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [_c("h5", [_vm._v("Datos Contacto")])]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Nombre y Apellidos"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.entity.datos_contacto,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "datos_contacto",
                                          $$v
                                        )
                                      },
                                      expression: "entity.datos_contacto"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Teléfono Principal"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    model: {
                                      value: _vm.entity.telefono_principal,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "telefono_principal",
                                          $$v
                                        )
                                      },
                                      expression: "entity.telefono_principal"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "font-size-1rem",
                                  attrs: {
                                    disabled: !_vm.searchedEntity,
                                    label: "Email Principal"
                                  }
                                },
                                [
                                  _c("b-form-input", {
                                    attrs: { name: "Email Principal" },
                                    model: {
                                      value: _vm.entity.email_principal,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "email_principal",
                                          $$v
                                        )
                                      },
                                      expression: "entity.email_principal"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "text-align-right" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex align-items-center justify-content-end"
                          },
                          [
                            !_vm.foundedEntity
                              ? _c(
                                  "b-form-checkbox",
                                  {
                                    staticClass: "d-block mr-16",
                                    model: {
                                      value: _vm.entity.enviar_notificacion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.entity,
                                          "enviar_notificacion",
                                          $$v
                                        )
                                      },
                                      expression: "entity.enviar_notificacion"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Enviar notificación\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.foundedEntity
                              ? _c("multiselect", {
                                  staticClass: "multiselect-user w-25 mx-16",
                                  attrs: {
                                    id: "multiselect-request-user",
                                    options: _vm.usersList,
                                    label: "username",
                                    "track-by": "username",
                                    placeholder: "",
                                    disabled: !_vm.entity.enviar_notificacion,
                                    "custom-label": _vm.getCustomLabelUser,
                                    size: "sm"
                                  },
                                  model: {
                                    value: _vm.entity.usuario_solicitante,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.entity,
                                        "usuario_solicitante",
                                        $$v
                                      )
                                    },
                                    expression: "entity.usuario_solicitante"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.foundedEntity
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.searchedEntity,
                                      variant: "primary"
                                    },
                                    on: { click: _vm.createEntity }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Alta\n              "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.foundedEntity
                              ? _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      disabled: !_vm.searchedEntity,
                                      variant: "primary"
                                    },
                                    on: { click: _vm.updateEntity }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Actualizar\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "success-alert",
              attrs: { variant: "success", dismissible: "" },
              model: {
                value: _vm.showSuccessAlert,
                callback: function($$v) {
                  _vm.showSuccessAlert = $$v
                },
                expression: "showSuccessAlert"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.successMessage) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "error-alert",
              attrs: { variant: "danger", dismissible: "" },
              model: {
                value: _vm.showErrorAlert,
                callback: function($$v) {
                  _vm.showErrorAlert = $$v
                },
                expression: "showErrorAlert"
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/CommercialManagement/AltaEntidad.vue?vue&type=template&id=6bb98d58&scoped=true&
// module id = null
// module chunks = 